export const PERSON_CONSTANT = {
  TYPE_APPLICANT: 'Applicant',
  SELECTED_PARTY_APPLICANT: 'Applicants',
  PARTY_TYPE_APPLICANT: '1',
  TYPE_MARRIED: '2',
};
